import styled, { css } from "styled-components";

const getHoverEffect = hoverColor => css`
  fill: ${hoverColor || "var(--du-color-hover)"};
  transition: fill 0.2s ease;
`;

const StyledSVG = styled.svg`
  path:not([fill]),
  rect:not([fill]),
  circle:not([fill]) {
    fill: var(--du-color-icon);
    transition: fill 0.2s ease;
    fill-opacity: ${({ hoverEffect }) => (hoverEffect ? 0.8 : 1)};
  }

  ${({ disabled }) =>
    disabled &&
    css`
      path,
      rect,
      circle {
        fill: var(--du-color-icon-disabled) !important;
        transition: fill 0.2s ease;
      }
    `}
`;

const Container = styled.div`
  display: inline-block;
  &:hover ${StyledSVG} {
    path,
    rect,
    circle {
      ${({ disabled, hoverColor }) => !disabled && getHoverEffect(hoverColor)}
      fill-opacity: 1;
    }
  }
`;

const SVGContainer = ({ disabled, hoverColor, hoverEffect, ...rest }) => (
  <Container disabled={disabled} hoverColor={hoverColor} hoverEffect={hoverEffect}>
    <StyledSVG disabled={disabled} hoverEffect={hoverEffect} {...rest} />
  </Container>
);

export default SVGContainer;
